export default __webpack_public_path__ + "static/media/insurance_icon.7dd2dc5a.svg";